import {InjectionToken, inject} from '@angular/core';
import {initializeApp, FirebaseApp} from 'firebase/app';
import {getMessaging, Messaging} from 'firebase/messaging';
import {environment} from '../environments/environment';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('firebase-app', {
  providedIn: 'root',
  factory: () => initializeApp(environment.firebase)
});

export const FIREBASE_MESSAGING = new InjectionToken<Messaging>('firebase-messaging', {
  providedIn: 'root',
  factory: () => {
    const app = inject(FIREBASE_APP);
    return getMessaging(app);
  }
});